import { ScrollSpyTabs } from '@components/scroll-spy';
import { TabsProps } from '@material-ui/core';
import styled from 'styled-components';

export const ScrollSpyMuiTabs = styled<React.FC<TabsProps & { $small?: boolean; $color?: string }>>(
  ScrollSpyTabs
)`
  .MuiTabs-indicator {
    background-color: ${props => props.$color || 'white'};
  }
  ${props =>
    props.$small &&
    `@media (min-width: 600px) {
    .MuiTab-root {
      min-width: auto;
    }
  }`}
`;
